module.exports = __webpack_public_path__ + "static/media/map_industrial_site.86683283.png";


//////////////////
// WEBPACK FOOTER
// ./public/pictures/markers/map_industrial_site.png
// module id = 2227
// module chunks = 0